import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

/**
 * Deletes a pricing category from a price scheme by its IDs.
 *
 * @param {string} priceSchemeId - The ID of the price scheme that contains the category.
 * @param {string} categoryId - The ID of the pricing category to delete.
 *
 * @returns {Promise<void>} A promise that resolves when the deletion is successful.
 * @throws {Error} If the deletion fails, an error is thrown.
 */
export const deletePriceSchemeCategory = async (priceSchemeId: string, categoryId: string): Promise<void> => {
  const url = `${API_URL}/pricing/schemes/${priceSchemeId}/categories/${categoryId}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (res.status === Status.BAD_REQUEST || res.ok === false) {
    throw new Error('Unable to delete Pricing Category. Please try again');
  }
};
